export default "__VITE_ASSET__B$WwR4Y7__"